/**
 * Names to be used as url search parameter keys
 */
enum UrlParameter {
	LANGUAGE = "lang"
}

export default UrlParameter;